import type { GuaranteesApplicationStatus } from '~/store/guarantees/types.ts';
import {
  isGuaranteesClientInitialSigningStatus,
  isGuaranteesClientStep3Status,
} from '~/modules/guarantees/utils.ts';
import type { TGuaranteesClientStepKey } from './types.ts';

export const getDisabledClientStepKeysByStatus = (
  status?: GuaranteesApplicationStatus | string | null
): TGuaranteesClientStepKey[] => [
  ...(!isGuaranteesClientInitialSigningStatus(status) ? (['step2'] as const) : []),
  ...(!isGuaranteesClientStep3Status(status) ? (['step3'] as const) : []),
];
